import type { ScentProfile } from './index.js';

export type PublicScentProfile = Omit<ScentProfile, 'basis' | 'sources'> & {
  editorialSupported: boolean;
};
export type ComparisonScentProfile = ScentProfile | PublicScentProfile;

/** Check internal evidence before removing it from public catalogue responses. */
export function hasEditorialSupport(profile: { basis?: unknown; sources?: unknown; reviewedAt?: unknown } | null | undefined): boolean {
  if (!profile || typeof profile.basis !== 'string' || !Array.isArray(profile.sources) || typeof profile.reviewedAt !== 'string') return false;
  const { basis, sources, reviewedAt } = profile;
  return basis.trim().length >= 20
    && Number.isFinite(Date.parse(reviewedAt))
    && Date.parse(reviewedAt) <= Date.now()
    && sources.some(url => typeof url === 'string' && /^https?:\/\//.test(url))
    && !/placeholder|example\.com/i.test(basis + ' ' + sources.join(' '));
}

/** Ratings and review dates remain public; editorial basis and source URLs stay in the CMS. */
export function publicScentProfile(value: unknown): PublicScentProfile | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const profile = value as ScentProfile;
  const { basis: _basis, sources: _sources, ...display } = profile;
  return { ...display, editorialSupported: hasEditorialSupport(profile) };
}
